











import Vue from "vue";
import { FitDialog } from "@/fit-ui";
import store from "./store";
import { hideDialog } from "@/fit-components/dialog/main";

export default Vue.extend({
  components: { FitDialog },
  data() {
    return {
      dialog: store.dialog
    };
  },
  methods: {
    handleClick(index) {
      if (
        this.dialog.btns &&
        this.dialog.btns[index] &&
        typeof this.dialog.btns[index].click === "function"
      ) {
        // @ts-ignore
        this.dialog.btns[index].click(hideDialog);
      } else {
        hideDialog();
      }
    }
  }
});
